export default __webpack_public_path__ + "static/media/slacklogo.7fdb245b.jpg";